export default __webpack_public_path__ + "static/media/Bienvenido-a-la-pagina-d.3cb02c21.png";